export default "__VITE_ASSET__31896432__"